<p>view-actemplate works!</p>
